import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import AuthContextSchema, { 
  AuthContextJSON, 
  AuthContextParams 
} from "users/auth/context/auth-context-schema";

export class AuthContext {
  public static readonly EXAMPLE: AuthContext = AuthContext.create({
    isClient: false,
    isVendor: true,
    viewingAsVendor: true,
    isVendorRepresentative: true,
    isClientRepresentative: false,
  })

  public static create(values: AuthContextParams): AuthContext {
    const parsed = AuthContextSchema.validate(values);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid AuthContext parameters.");
    }
    return new AuthContext(parsed);
  }

  public static fromJSON(json: AuthContextJSON): AuthContext {
    if (isNullOrUndefined(json)) return json;
    const params = AuthContextSchema.deserialize(json);
    return new AuthContext(params);
  }

  public readonly isVendor: boolean;
  public readonly isClient: boolean;
  public readonly viewingAsVendor: boolean | null;
  public readonly isVendorRepresentative: boolean;
  public readonly isClientRepresentative: boolean;
  // public readonly timestamp: AHDate;

  public constructor(params: AuthContextParams) {
    this.isVendor = params.isVendor;
    this.isClient = params.isClient;
    this.viewingAsVendor = params.viewingAsVendor;
    this.isVendorRepresentative = params.isVendorRepresentative;
    this.isClientRepresentative = params.isClientRepresentative;
  }

  public toJSON(): AuthContextJSON {
    return AuthContextSchema.serialize(this);
  }

  public isEqualTo(other: AuthContext): boolean {
    return (
      this.isVendor === other.isVendor &&
      this.isClient === other.isClient &&
      this.viewingAsVendor === other.viewingAsVendor &&
      this.isVendorRepresentative === other.isVendorRepresentative &&
      this.isClientRepresentative === other.isClientRepresentative
      // && this.timestamp.isEqualTo(other.timestamp)
    );
  }

  public toString(): string {
    return `AuthContext { 
      isVendor: ${this.isVendor},
      isClient: ${this.isClient}, 
      viewingAsVendor: ${this.viewingAsVendor}, 
      isVendorRepresentative: ${this.isVendorRepresentative}, 
      isClientRepresentative: ${this.isClientRepresentative}, 
    }`;
  }
}
